import { NgModule } from '@angular/core';
import { AspectRatioDirective, AssetImageDirective } from '../directives';
import { ForbidCharsDirective, ToLocalizedValuePipe } from 'addiction-components';
import { BytesPipe } from '../pipes/bytes.pipe';

@NgModule({
	declarations: [AssetImageDirective, AspectRatioDirective, BytesPipe],
	imports: [ForbidCharsDirective],
	exports: [AssetImageDirective, ForbidCharsDirective, BytesPipe],
	providers: [ToLocalizedValuePipe],
})
export class DataleanDirectiveModule {}
